// Copyright (c) 2021 WiseTime. All rights reserved.

import React, { useState } from "react"
import styled, { css } from "styled-components/macro"
import { Trans } from "@lingui/react"
import { ActionPaneButton, Paper, SecondaryButton } from "../../shared/styles"
import { darken } from "polished"

const Wrapper = styled.div<{ isActionPane: boolean }>`
  ${Paper};
  background-color: ${({ theme }) => theme.colors.alabaster};
  box-shadow: 0 1px 3px rgba(0, 0, 0, .15);
  padding: 10px;
  min-width: 319px;
  font-weight: 400;

  ${({ isActionPane }) => {
    if (isActionPane) {
      return css`
        position: absolute;
        top: -10px;
        left: 0;
        transform: translate3d(0, -100%, 0);
      `
    }
  }};

  @media (max-width: ${({ theme }): string => theme.screen.xs}) {
    ${({ isActionPane }) => {
    if (isActionPane) {
      return css`
        min-width: 294px;
        left: -30px;
      `
    }
      
    return css`
      min-width: 280px;
      left: -140px;
    `
  }}}; 

  &:after {

    ${({ isActionPane }) => {
    if (isActionPane) {
      return css`
        content: "";
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid white;
        position: absolute;
        bottom: -7px;
        left: 49px;
        z-index: 1;
        filter: drop-shadow(0 2px 1px rgba(0, 0, 0, .15));
      `
    }

    return css`
      left: 185px;
    `
  }}};
`

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  
  > * {
    margin-top: 1rem;
  }
`

const AcceptSection = styled.div`
  display: flex;
  align-items: center;
`

const ButtonOk = styled(ActionPaneButton)`
  background-color: ${({ theme }) => theme.colors.tropicalRainForest};
  color: ${({ theme }) => theme.colors.white};
  transition: background-color .3s ease;

  &:hover {
    background-color: ${({ theme }): string => darken(0.05, theme.colors.tropicalRainForest)};
  }
`

const Checkbox = styled.label`
  margin-left: 10px;
  
  input {
    margin-right: 5px;
    vertical-align: -1px;
  }
`

type Props = {
  className?: string,
  isActionPane?: boolean,
  handleOk: (dontAskAgain: boolean) => void,
  handleCancel: () => void,
}

const WarnMultipleTagsPopup = ({
  className,
  handleOk,
  handleCancel,
  isActionPane = false,
}: Props): React.ReactElement<Props> => {
  const [dontAskAgain, changeDontAskAgain] = useState<boolean>(false)
  return (
    <Wrapper className={className} isActionPane={isActionPane}>
      <Trans
        id="msg_warnign_multiple_tags"
        message="You are about to post time to multiple matters. The duration will be split equally among these matters. Do you wish to proceed?"
      />
      <Footer>
        <AcceptSection>
          <ButtonOk
            type="button"
            onClick={() => handleOk(dontAskAgain)}
          ><Trans id="label_ok" message="OK"/></ButtonOk>
          <Checkbox>
            <input
              type="checkbox"
              checked={dontAskAgain}
              onChange={e => changeDontAskAgain(e.target.checked)}
            />
            <Trans id="label_dont_ask_again" message="Don't ask again"/>
          </Checkbox>
        </AcceptSection>
        <SecondaryButton
          type="button"
          onClick={handleCancel}
        >
          <Trans id="button_cancel" message="Cancel"/>
        </SecondaryButton>
      </Footer>
    </Wrapper>
  )
}

export default WarnMultipleTagsPopup
